import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import ApproveModalDelivery from '../../../../app/common/modals/ApproveModalDelivery';
import { useStore } from '../../../../app/stores/store';
import DynamicDeliveryTable from '../../../DynamicTable/DynamicDeliveryTable';

interface Props {
  size: string;
}
function DeliveryTable({ size }: Props) {
  const { dashboardStore, DeliveryStore, commonStore } = useStore();
  const {
    listApproveDelivery,
    ApproveRegisterTable,
    listAssignPickerDelivery,
    AssignPickerRegisterTable,
    listCreateOrder,
    createOrderTable,
    assignPickerRegistry,
    listDelivery,
    deliveryTable,
  } = DeliveryStore;
  const { userReadableDateFormat } = commonStore;
  const [mainTD, setMainTD] = useState([]);
  const [mainTD2, setMainTD2] = useState([]);
  const [mainTD3, setMainTD3] = useState([]);
  const [mainTD4, setMainTD4] = useState([]);
  const [mainTD5, setMainTD5] = useState<any>([]);
  const [L2, setL2] = useState('');
  const [L3, setL3] = useState('');
  const [actionType, setActionType] = useState<string>('');

  useEffect(() => {
    setL2(dashboardStore.dashboard.L2CardValueInventory);
  }, [dashboardStore.dashboard.L2CardValueInventory]);

  useEffect(() => {
    setL3(dashboardStore.dashboard.valueForL3Inventory);
  }, [dashboardStore.dashboard.valueForL3Inventory]);

  // filter to check is approved in delivery
  useEffect(() => {
    if (L2 === 'Delivery') {
      if (L3 === 'Approve') {
        listApproveDelivery();
      } else if (L3 === 'Assign Picker Delivery') {
        listAssignPickerDelivery();
      } else if (L3 === 'Create Order') {
        listCreateOrder();
      } else if (L3 === 'Delivery') {
        listDelivery();
      }
    }

    // eslint-disable-next-line
  }, [L2, L3]);

  useEffect(() => {
    setMainTD2([]);
    setMainTD3([]);
    setMainTD4([]);
    setMainTD([]);
    let newArr: any = [];
    if (L2 === 'Delivery' && L3 === 'Approve') {
      ApproveRegisterTable.forEach((x) => {
        x?.itemDeliveryRequest.forEach((y: any) => {
          newArr.push(y);
        });
      });
    }
    setMainTD(newArr);
    setMainTD5((oldState: any) => [...oldState, ...newArr]);
    // eslint-disable-next-line
  }, [ApproveRegisterTable]);

  useEffect(() => {
    let newArr: any = [];
    setMainTD2([]);
    setMainTD3([]);
    setMainTD([]);
    setMainTD4([]);

    if (L2 === 'Delivery' && L3 === 'Assign Picker Delivery') {
      AssignPickerRegisterTable.forEach((x) => {
        x.itemDeliveryRequest.forEach((y: any) => {
          newArr.push(y);
        });
      });
    }
    setMainTD2(newArr);
    setMainTD5((oldState: any) => [...oldState, ...newArr]);
    // eslint-disable-next-line
  }, [assignPickerRegistry.size]);

  useEffect(() => {
    let newArr: any = [];
    setMainTD2([]);
    setMainTD3([]);
    setMainTD([]);
    setMainTD4([]);
    if (L2 === 'Delivery' && L3 === 'Create Order') {
      createOrderTable.forEach((x) => {
        x.itemDeliveryRequest.forEach((y: any) => {
          newArr.push(y);
        });
      });
    }
    setMainTD3(newArr);
    setMainTD5((oldState: any) => [...oldState, ...newArr]);
    // eslint-disable-next-line
  }, [createOrderTable]);

  useEffect(() => {
    let newArr: any = [];
    setMainTD2([]);
    setMainTD3([]);
    setMainTD([]);
    setMainTD4([]);
    if (L2 === 'Delivery' && L3 === 'Delivery') {
      deliveryTable.forEach((x) => {
        x?.itemDeliveryRequest &&
          x?.itemDeliveryRequest?.forEach((y: any) => {
            newArr.push(y);
          });
      });
    }
    setMainTD4(newArr);
    setMainTD5((oldState: any) => [...oldState, ...newArr]);
    // eslint-disable-next-line
  }, [deliveryTable]);

  const MainFilter =
    L2 === 'Delivery' && L3 === 'Approve'
      ? mainTD
      : L2 === 'Delivery' && L3 === 'Assign Picker Delivery'
        ? mainTD2
        : L2 === 'Delivery' && L3 === 'Create Order'
          ? mainTD3
          : L2 === 'Delivery' && L3 === 'Delivery'
            ? mainTD4
            : mainTD5;

  const removeCol =
    'clearedon,files,assignedUsers,comments,itemHistory,orders,itemDeliveryRequest,inwards,receivings,host,isDeleted,isActive,cast,thumbnail_large,thumbnail_small,groove_type,speed_and_speed_adjustment,number_of_channels_and_sound_channel_map,file_format_name_and_version,analog_media,format_in_terms_of_broadcast_standards,bits_per_sample_and_sampling_description,songs,physcial_format,host,hostUsername,originIndia,itemCreatedAt,inactive,isgoing,ishost,';
  const tableData: any = [];
  const ids = MainFilter?.map((o: any) => o.id);
  const filtered = MainFilter?.filter(
    ({ id }: any, index: any) => !ids.includes(id, index + 1),
  );
  filtered?.forEach((a: any) => {
    tableData.push({
      ...a,
      dateRequestRaised: userReadableDateFormat(a?.dateRequestRaised),
    });
  });
  const DeliveryTable = JSON.parse(JSON.stringify(tableData));
  DeliveryTable.map((i: any) => removeCol.split(',').map((j) => delete i[j]));

  const [showText, setShow] = useState(false);

  useEffect(() => {
    setShow(true);
  }, [MainFilter]);

  useEffect(() => {
    if (L2 === 'Delivery' && L3 === 'Approve') {
      setActionType('Approve|Deny');
    }
  }, [L2, L3]);

  const assetTableData = (
    <DynamicDeliveryTable
      data={DeliveryTable}
      name={size}
      actiontype={actionType}
    />
  );

  return (
    <div
      className="table-dash"
      // style={{ overflow: "auto", height: "63vh" }}
    >
      {dashboardStore.dashboard.DenialModal ? (
        <ApproveModalDelivery />
      ) : dashboardStore.dashboard.reportsConfiguration ? (
        // <ReportsModal />
        <></>
      ) : null}
      {showText && assetTableData}
    </div>
  );
}

export default observer(DeliveryTable);
